import { track as amplitudeTrack } from './amplitude';
import { track as intercomTrack } from './intercom';

export const useAnalytics = () => {
	return {
		track: amplitudeTrack, // retro compatible with current analytics
		trackEvent, // multi platform event tracking
	};
};

function trackEvent(event: string, data?: any) {
	// track to amplitude
	amplitudeTrack(event, data);
	// track to Intercom
	intercomTrack(event, data);
}
